<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>版本下发列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="r-list" v-show="false">
            <div class="search-box">
              <el-input placeholder="输入关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>

            <el-table-column label="系统类型">
              <template slot-scope="scope">
                <!-- <span>未知</span> -->
                {{
                  scope.row.parameters.versionType == 1 ? "Windows" : "Android"
                }}
              </template>
            </el-table-column>
            <el-table-column label="设备">
              <template slot-scope="scope">
                <span
                  v-for="(it, index) in scope.row.parameters.cabinetCodes"
                  :key="index"
                >
                  {{ it }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="版本名称">
              <template slot-scope="scope">
                {{ scope.row.parameters.versionNameLike || "" }}
              </template>
            </el-table-column>
            <el-table-column label="版本号">
              <template slot-scope="scope">
                {{ scope.row.parameters.softVer || "" }}
              </template>
            </el-table-column>

            <el-table-column
              prop="gmtCreate"
              label="下发日期"
            ></el-table-column>
            <el-table-column prop="createdBy" label="操作人"></el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-search"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {
    dialogShow: function (_id) {
      this.dialogVisible = true;
    },
    dialogClose: function () {
      this.dialogVisible = false;
    },
    //加载图片地址
    loadImage: function (src) {
      if (!src.startsWith("/")) return src;
      return baseApi + src;
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/cmd/cmdBatchPage";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      sendUrl += "&cmd=updateSoft";
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content.map(function (item) {
            if (item.parameters) {
              const jsonstr = item.parameters
                .toString()
                .replace(/&quot;/g, '"');
              const parsms = eval("(" + jsonstr + ")");
              item.parameters = parsms;
            } else {
              item.parameters = {};
            }
            return item;
          });
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Versioning/DistributeList.vue